<header mat-dialog-title class="history-heading">
    <div>
        <span class="history-eyebrow"><i class="bi bi-clock-history" aria-hidden="true"></i> Work history</span>
        <h2>Master #{{ data.text }}</h2>
        <p>{{ data.content.length }} {{ data.content.length === 1 ? 'record' : 'records' }} of work on this file</p>
    </div>
    <button class="history-close" type="button" aria-label="Close history" (click)="dialogRef.close()"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
</header>
<mat-dialog-content class="history-content">
    <div class="history-list">
        @for (element of data.content; track $index) {
            <article class="history-entry">
                <div class="entry-heading">
                    <div class="entry-person"><span class="entry-index">{{ $index + 1 }}</span><strong>{{ element.firstName }} {{ element.lastName }}</strong></div>
                    <span class="entry-time"><i class="bi bi-clock" aria-hidden="true"></i>{{ formatWorkTime(element.workTime) }}</span>
                </div>
                <span class="entry-status">{{ element.status || 'Status not recorded' }}</span>
                <dl class="history-details">
                    <div><dt>Version name</dt><dd>{{ element.versionName || '—' }}</dd></div>
                    <div class="full-width"><dt>Version comment</dt><dd>{{ element.versionComment || '—' }}</dd></div>
                </dl>
            </article>
        } @empty {
            <div class="history-empty"><i class="bi bi-clock-history" aria-hidden="true"></i><span>No history recorded for this Master.</span></div>
        }
    </div>
</mat-dialog-content>
